export const AMOUNT_TYPE = {
  FIXED: "FIXED",
  FIXED_OPTIONS: "FIXED_OPTIONS",
  DYNAMIC: "DYNAMIC",
} as const;

export const PAYMENT_STATUS = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  PENDING: "PENDING",
} as const;

export type PaymentStatus = (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export const REDIRECT_TYPE = {
  REDIRECT_URL: "REDIRECT_URL",
  MESSAGE: "MESSAGE",
} as const;

export const VALIDATION_TYPE = {
  DROPDOWN: "DROPDOWN",
  DATE: "DATE",
  VALIDATED_TEXT_FIELD: "VALIDATED_TEXT_FIELD",
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  FILE_UPLOAD: "FILE_UPLOAD",
} as const;

export const VALIDATION_SUB_TYPE = {
  VALIDATED_TEXT_FIELD_LIST: "VALIDATED_TEXT_FIELD_LIST",
  VALIDATED_TEXT_FIELD_DATASOURCE: "VALIDATED_TEXT_FIELD_DATASOURCE",
} as const;

export const CURRENCY_CODE = "NGN";

export const DEFAULT_PAYMENT_METHODS = ["CARD", "ACCOUNT_TRANSFER"] as const;

export const PAYLINK_BASE_URL = "https://paylink.monnify.com";

export const MONNIFY_LOADING_LOGO_URL = "https://app.monnify.com/images/logo-white.svg";
export const MONIEPOINT_LOADING_LOGO_URL = "https://app.monnify.com/images/moniepointLogo-white.svg";

export const COUNTDOWN_SECONDS = 30;

export const MAX_AUTO_RETRIES = 3;
